var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo, useRef } from 'react';
import { Text, TextInput, View, TouchableOpacity } from 'react-native';
import { useStyle } from './style';
const Input = forwardRef((_a, ref) => {
    var { kidtoken = '', size = 'small', border = false, value, editable = true, disabled = false, placeholder = '请输入', maxLength = undefined, showWordLimit = false, showArrow = false, customStyle = {}, scalable = false, clearable = false, exceedLimit = false } = _a, rest = __rest(_a, ["kidtoken", "size", "border", "value", "editable", "disabled", "placeholder", "maxLength", "showWordLimit", "showArrow", "customStyle", "scalable", "clearable", "exceedLimit"]);
    const { vars, style } = useStyle({ kidtoken, scalable, customStyle });
    const innerRef = useRef(null);
    const innerTextInputRef = ref ? ref : innerRef;
    const clearValue = () => {
        var _a;
        (_a = innerTextInputRef === null || innerTextInputRef === void 0 ? void 0 : innerTextInputRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        rest.onChangeText && rest.onChangeText('');
    };
    const wrapStyle = [
        style.inputWrap,
        style[`${size}`],
        border ? style.border : {},
    ];
    const inputStyle = [style.common, disabled ? style.disabled : {}];
    const limitStyle = [
        style.inputLength,
        (value === null || value === void 0 ? void 0 : value.length) >= maxLength ? style.inputLengthLimit : {},
    ];
    const limitLength = useMemo(() => {
        // 只有在maxLength有值的时候设置exceedLimit=true才有意义
        return maxLength && !exceedLimit ? maxLength : undefined;
    }, [exceedLimit, maxLength]);
    const Limit = (React.createElement(View, { style: style.limitWrap },
        React.createElement(Text, { style: [limitStyle] }, value === null || value === void 0 ? void 0 : value.length),
        React.createElement(Text, { style: style.maxLength }, `/${maxLength}`)));
    // const Arrow = (
    //     <TouchableOpacity
    //         activeOpacity={1}
    //         style={[style.arrow]}
    //         onPress={rest.onArrowClick}
    //         testID="arrowIcon"
    //     >
    //         <Icon
    //             scalable={scalable}
    //             customStyle={{
    //                 iconColor: vars.kid_input_color_arrow_icon,
    //                 iconSize: vars.kid_input_size_arrow_icon_custom,
    //             }}
    //             name="kuc_common_base_next_24"
    //         />
    //     </TouchableOpacity>
    // );
    // const Clear = value?.length > 0 && (
    //     <TouchableOpacity
    //         activeOpacity={1}
    //         style={[style.clear]}
    //         onPress={clearValue}
    //         testID="clearIcon"
    //     >
    //         <Icon
    //             scalable={scalable}
    //             customStyle={{
    //                 iconSize: vars.kid_input_size_clear_icon_custom,
    //             }}
    //             name="kuc_common_baseflat_cdeletetext_24"
    //         />
    //     </TouchableOpacity>
    // );
    // const RightElement = () => {
    //     if (showWordLimit && maxLength) {
    //         return Limit;
    //     } else if (showArrow) {
    //         return Arrow;
    //     }
    // };
    return (React.createElement(TouchableOpacity, { testID: "inputWrap", style: wrapStyle, activeOpacity: 1 },
        React.createElement(TextInput, Object.assign({ testID: "input", value: value, ref: innerTextInputRef, style: inputStyle, editable: editable && !disabled, maxLength: limitLength, placeholder: placeholder, numberOfLines: 1, placeholderTextColor: vars.kid_input_color_placeholder_font, onTouchStart: rest.onPress }, rest))));
});
export { Input };
